class CartGlueUpsell {
  constructor(element) {
    this.element = element;
    this.variantId = Number(element.dataset.glueVariantId);
    this.cartAddUrl = element.dataset.cartAddUrl;
    this.dialog = element.querySelector('.cart-glue-upsell__dialog');
    this.addButton = element.querySelector('[data-glue-upsell-add]');
    this.skipButton = element.querySelector('[data-glue-upsell-skip]');
    this.status = element.querySelector('[data-glue-upsell-status]');
    this.checkoutForm = null;
    this.lastFocusedElement = null;
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  init() {
    document.addEventListener('keydown', this.onKeyDown);
    this.element.dataset.state = 'ready';

    this.element.querySelectorAll('[data-glue-upsell-close]').forEach((button) => {
      button.addEventListener('click', () => this.close());
    });
    this.addButton.addEventListener('click', () => this.addGlue());
    this.skipButton.addEventListener('click', () => this.continueToCheckout());
  }

  interceptCheckout(event, checkoutButton) {
    event.preventDefault();
    this.handleCheckout(checkoutButton.form || checkoutButton.closest('form'), checkoutButton);
    return false;
  }

  handleCheckout(form, checkoutButton) {
    this.checkoutForm = form;
    this.lastFocusedElement = checkoutButton;
    this.element.dataset.state = 'offer-open';
    this.open();
  }

  open() {
    this.status.hidden = true;
    this.status.textContent = '';
    this.element.hidden = false;
    document.body.classList.add('cart-glue-upsell-open');
    this.addButton.focus();
  }

  close() {
    this.element.hidden = true;
    document.body.classList.remove('cart-glue-upsell-open');
    this.lastFocusedElement?.focus();
  }

  async addGlue() {
    this.addButton.disabled = true;
    this.skipButton.disabled = true;
    this.addButton.classList.add('loading');
    this.addButton.querySelector('.loading__spinner')?.classList.remove('hidden');
    this.status.hidden = true;

    try {
      const response = await fetch(`${this.cartAddUrl}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: this.variantId,
              quantity: 1,
              properties: { _added_from: 'checkout_glue_offer' },
            },
          ],
        }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'The glue could not be added.');
      }

      this.continueToCheckout();
    } catch (error) {
      this.status.textContent = error.message || 'The glue could not be added. Please try again.';
      this.status.hidden = false;
      this.addButton.disabled = false;
      this.skipButton.disabled = false;
      this.addButton.classList.remove('loading');
      this.addButton.querySelector('.loading__spinner')?.classList.add('hidden');
    }
  }

  continueToCheckout() {
    document.body.classList.remove('cart-glue-upsell-open');

    if (this.checkoutForm) {
      const checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'Checkout';
      this.checkoutForm.appendChild(checkoutInput);
      HTMLFormElement.prototype.submit.call(this.checkoutForm);
      return;
    }

    window.location.assign('/checkout');
  }

  onKeyDown(event) {
    if (this.element.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = [...this.dialog.querySelectorAll('button:not([disabled]), a[href]')];
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}

const cartGlueUpsell = document.getElementById('CartGlueUpsell');
if (cartGlueUpsell) {
  window.cartGlueUpsell = new CartGlueUpsell(cartGlueUpsell);
  window.cartGlueUpsell.init();
}
